/**
 * @generated SignedSource<<bec4840fa79bda98e0aee61c3549b5a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type shippingCostHelpers_item$data = {
  readonly shipmentQuotes: ReadonlyArray<{
    readonly isComplimentary: boolean | null;
    readonly serviceMethod: {
      readonly region: {
        readonly regionName: string | null;
      } | null;
    } | null;
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
    readonly type: string | null;
  } | null> | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "shippingCostHelpers_item";
};
export type shippingCostHelpers_item$key = {
  readonly " $data"?: shippingCostHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shippingCostHelpers_item"
};

(node as any).hash = "224adb1a31662fa4f6fe43dd8a1bcbfc";

export default node;
